import { Dialog, DialogContent } from "../components/ui/dialog";
import {  useDispatch } from "react-redux";
import { useAuth } from "wasp/client/auth";
import ShopifyReconnectView from "../views/ShopifyReconnectView";
import { useTranslation } from "../i18n/hooks";

type ReconnectDialogProps = {
  open: boolean;
  onOpenChange: (arg: boolean) => void;
};

const ReconnectDialog = ({open, onOpenChange}: ReconnectDialogProps) => {
  const dispatch = useDispatch();
  const { data: user } = useAuth();
  const { t } = useTranslation();

  if (!user) return null;

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent>
         <ShopifyReconnectView/>
      </DialogContent>
    </Dialog>
  );
};

export default ReconnectDialog;
